import React from 'react';
import styled from 'styled-components';
import { Grid, Cell } from '../grid';

const LogoIconSectionContainer = styled.div`
  border-bottom: 1px solid #ebebeb;
`;

const LogoIconSectionInner = styled.div`
  max-width: 990px;
  padding-bottom: 100px;
  margin: 0 auto;
`;

const IconContainer = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;

  img {
    max-width: 130px;
    max-height: 45px;
    margin: 0;
  }
`;

function LogoIconSection({ input }) {
  return (
    <LogoIconSectionContainer>
      <LogoIconSectionInner>
        <Grid columns={10} rowGap={'56px'}>
          {input.items.map((item, i) => {
            return (
              <Cell key={i} xs={5} sm={2}>
                <IconContainer>
                  <img src={item.icon.url} />
                </IconContainer>
              </Cell>
            );
          })}
        </Grid>
      </LogoIconSectionInner>
    </LogoIconSectionContainer>
  );
}

export { LogoIconSection };
